import { http } from './http-client';
import type { SportDto, SportUnfinishedResponse } from './generated';

export type SportCode = 'padel' | 'tennis' | 'volleyball' | 'squash' | (string & {});

export type SportUpdatePayload = Partial<
  Pick<SportDto, 'label' | 'sortOrder' | 'icon' | 'color' | 'state'>
>;

export interface SportCreatePayload {
  code: string;
  label: string;
  icon?: string;
  color?: string;
}

export const sportsApi = {
  list(call?: { signal?: AbortSignal }): Promise<{ items: SportDto[] }> {
    return http.get<{ items: SportDto[] }>('/sports', { signal: call?.signal });
  },
  create(payload: SportCreatePayload): Promise<SportDto> {
    return http.post<SportDto>('/sports', payload);
  },
  update(code: SportCode, payload: SportUpdatePayload): Promise<SportDto> {
    return http.patch<SportDto>(`/sports/${code}`, payload);
  },
  unfinished(code: SportCode, call?: { signal?: AbortSignal }): Promise<SportUnfinishedResponse> {
    return http.get<SportUnfinishedResponse>(`/sports/${code}/unfinished`, { signal: call?.signal });
  },
  remove(code: SportCode): Promise<void> {
    return http.delete<void>(`/sports/${code}`);
  },
};
